module.exports = __webpack_public_path__ + "img/top_bg.c34ebb64.png";